
import { Component } from "vue-property-decorator";
import picker from "@/components/common/PickerDialog.vue";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import {
  saveDailyTrackingSettings,
  getDailyTrackingSettings,
} from "@/data/repository/ClientRepository";
import { DailyTrackingSettings } from "@/data/models/Client";
import SettingsPageMixin from "@/components/settings/SettingsPageMixin";

@Component({
  components: { picker, "confirmation-dialog": ConfirmationDialog },
})
export default class DailyTrackingSettingsComponent extends SettingsPageMixin {
  dailyTrackingSettings: DailyTrackingSettings | null = null;
  
  createDailyTracking = false;
  sendDailyTracking = false;

  private initialCreateDailyTracking = false;
  private initialSendDailyTracking = false;

  yesNoValues = [true, false];

  get formatYesNo() {
    return (value: boolean) => {
      return this.$t(`common.${value ? "yes" : "no"}`).toString();
    };
  }

  get hasChanged(): boolean {
    return (
      this.createDailyTracking !== this.initialCreateDailyTracking ||
      this.sendDailyTracking !== this.initialSendDailyTracking
    );
  }

  async mounted() {
    this.setToolbarTitle(this.$t("settings.timeTracking.dailyTracking").toString());
    await this.loadDailyTrackingSettings();
  }

  async doSave() {
    await saveDailyTrackingSettings({
      createDailyTracking: this.createDailyTracking,
      sendDailyTracking: this.sendDailyTracking,
    });
  }

  async loadDailyTrackingSettings(){
    this.dailyTrackingSettings = await getDailyTrackingSettings();

    this.createDailyTracking = this.dailyTrackingSettings?.createDailyTracking ?? false;
    this.sendDailyTracking = this.dailyTrackingSettings?.sendDailyTracking ?? false;

    this.initialCreateDailyTracking = this.createDailyTracking;
    this.initialSendDailyTracking = this.sendDailyTracking;
  }
}
